const m: Record<string, string> = { low: '🟢', medium: '🟡', high: '🔴' }
export default function RiskDot({ level }: { level: string }) {
  return <span className="text-base">{m[level] || '⚪'}</span>
}
